/**
 * Tiny slugify utility for auto-generating URL paths from page titles.
 *
 * Rules:
 *   - Lowercase
 *   - Replace spaces and non-alphanumeric chars with hyphens
 *   - Collapse consecutive hyphens
 *   - Trim leading/trailing hyphens
 *   - Basic unicode normalization (accented chars to ASCII)
 *
 * Example: "About Our Firm" -> "about-our-firm"
 */
export function slugify(text: string): string {
  return (
    text
      // Normalize unicode (NFD decomposes accented chars into base + combining)
      .normalize("NFD")
      // Strip combining diacritical marks (U+0300..U+036F)
      .replace(/[\u0300-\u036F]/g, "")
      .toLowerCase()
      // Replace any non-alphanumeric character with a hyphen
      .replace(/[^a-z0-9]+/g, "-")
      // Collapse consecutive hyphens
      .replace(/-{2,}/g, "-")
      // Trim leading/trailing hyphens
      .replace(/^-+|-+$/g, "")
  );
}
